const POINT_COUNT = 3;

export {POINT_COUNT};
